
import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getHomePath } from "../utils/moduleAccess";

const Login = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || null;

    if (user?.accessToken) {
      navigate(getHomePath(user.userRole?.[0]));
    }
  }, [navigate]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
        {
          username: data.username,
          password: data.password,
        }
      );

      localStorage.setItem("user", JSON.stringify(res.data));

      if (res.data.userRole[0] === "ADMIN") {
        const org = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${encodeURIComponent(
            res.data.username
          )}`,
          {
            headers: {
              Authorization: `Bearer ${res.data.accessToken}`,
            },
          }
        );

        localStorage.setItem("org", JSON.stringify(org.data.orgId));

        if (!org.data.orgUsername && !org.data.orgShortform) {
          navigate("/admin/org-details");
        } else {
          navigate(getHomePath("ADMIN"));
        }
      } else {
        navigate(getHomePath(res.data.userRole[0]));
      }
    } catch (error) {
      setError("Login failed. Invalid user ID or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="App"
      style={{
        position: "relative",
      }}
    >
      {loading && <div className="loading-div"></div>}

      {/* Existing login form */}
      <div
        className="border-container"
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <h2>Login</h2>

        <form onSubmit={handleLogin}>
          <label htmlFor="username">Email ID</label>
          <input
            type="email"
            name="username"
            id="username"
            onChange={handleChange}
            required
          />

          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
            required
          />

          {error && <span className="error">{error}</span>}

          <div style={{ display: "flex", justifyContent: "end" }}>
            <a href="/forgot-password" style={{ fontSize: "12px" }}>
              Forgot Password?
            </a>
          </div>

          <Button
            type="submit"
            className="btn-contained"
            sx={{ width: "100% !important" }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
